// @flow

const breakPoints = [
  70,
  80,
  79,
  70,
  60,
  35,
  30,
  25,
  15,
  10,
  8,
  5,
  5,
  0,
  -20,
  -20,
  0,
  5,
  5,
  8,
  10,
];
const resolution = 2; // ブレイクポイント間のセル数
let prevBreakpoint: number = breakPoints.shift();
let lastElevation: number = prevBreakpoint;

const x: number[] = breakPoints.reduce((acc, breakpoint, i) => {
  const diff = breakpoint - prevBreakpoint;
  const step = diff / resolution;
  prevBreakpoint = breakpoint;

  for (let i = 0; i < resolution; i++) {
    lastElevation += step;
    acc.push(Math.round(lastElevation));
  }

  return acc;
}, []);

export default {
  cellElevations: [x],
  // 水面高度
  submergeThreshold: 0,
  // デフォルトの土壌栄養量を以下の数字で割る（数字が大きいほど難易度が高くなる）
  difficulty: 1,
  sunlight: 100,
  defaultVirtualTimeInterval: 1000,
  unitZonbieTime: 3,
};



// WEBPACK FOOTER //
// ./src/lib/settings/settings.js